import { FETCH_CONSTRAINTS } from "../../constants/constraints";
import { feeds } from "../../apis/services";

export const fetchConstraints = () => {
  return {
    type: FETCH_CONSTRAINTS,
    payload: feeds.getConstraints(),
  };
};
